import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderWidth, borderStyle } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";
import type { DetailFieldSize } from "./DetailField.types";

type SizeProp = { $size: DetailFieldSize };

export const Wrapper = styled.div<SizeProp & { $boxed?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $size }) => ($size === "sm" ? spacing[0.5] : spacing[1])};
  min-width: 0;

  ${({ $boxed, $size, theme }) =>
    $boxed &&
    css`
      /* GAP: Figma stat tiles use structural/theme-light, which has no theme
         (dark-mode) token yet — md keeps the themed detailField surface. */
      background-color: ${$size === "sm"
        ? rawColors.structural.themeLight
        : theme.colors.surface.detailField};
      border: ${borderWidth[1]} ${borderStyle.solid} ${theme.colors.border.stroke};
      border-radius: ${theme.borders.radius.xl};
      padding: ${$size === "sm"
        ? `${spacing[2]} ${spacing[3]}`
        : `${spacing[3]} ${spacing[4]}`};
    `}
`;

export const Label = styled.span<SizeProp>`
  ${({ $size }) => ($size === "sm" ? typographyMixin("caption", 4) : typographyMixin("body", 4))}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Value = styled.span<SizeProp>`
  ${({ $size }) => ($size === "sm" ? typographyMixin("body", 3) : typographyMixin("subtitle", 3))}
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
